import { defineStore } from 'pinia';
import { AuctionsRequestFilter, AuctionStatus } from '@/types/auction.type.ts';
import {
    CarMaxMileage,
    CarMaxPrice,
    CarMaxProductionYear,
    CarMinProductionYear,
} from '@/types/car.type.ts';

export const useAuctionsFilterStore = defineStore('auctions.filter', {
    state: (): AuctionsRequestFilter => ({
        brand_ids: undefined,
        model_ids: undefined,
        from_date: undefined,
        to_date: undefined,
        status: [AuctionStatus.InProgress],
        start_price: [0, CarMaxPrice],
        transmission_type: undefined,
        mileage: [0, CarMaxMileage],
        production_year: [CarMinProductionYear, CarMaxProductionYear],
        city_ids: undefined,
        dealer_ids: undefined,
        confirmation_required: undefined,
        joining: undefined,
        sort: [{ start_date: 'desc' }],
        page: 1,
    }),
});
